/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Identifies which part of a physical dimension an AttributeValue row holds. Only attributes
 * of type DimensionType carry a part; every other attribute type stores a single value row
 * with a null part.
 */
export enum Shared_DimensionParts {
    /**
     * Height in millimetres.
     */
    Height = 10,
    /**
     * Width in millimetres.
     */
    Width = 20,
}
